function isNumber(x) {
    return typeof x === 'number' || x instanceof Number;
}

export { isNumber };
